import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {useLanguage} from '../../utils/LanguageContext';

/* global requestAnimationFrame */
const PrintStepsModal = props => {
  const [preparingDocument, setPreparingDocument] = useState(false);
  const {selectedLanguage} = useLanguage();

  if (!props.show) {
    return null;
  }

  const smoothScrollTo = (targetPosition, duration) => new Promise(resolve => {
    const startPosition = window.scrollY;
    const distance = targetPosition - startPosition;
    let startTime = null;

    const animation = currentTime => {
      if (!startTime) {
        startTime = currentTime;
      }

      const timeElapsed = currentTime - startTime;
      const progress = Math.min(timeElapsed / duration, 1); // Cap at 1 (100%)

      // Slow easing function for smooth and slow scrolling
      const ease = progress < 0.5
        ? progress * progress
        : (-1 * Math.pow(progress - 1, 2)) + 1;

      const currentScroll = startPosition + (distance * ease);
      window.scrollTo(0, currentScroll);

      if (timeElapsed < duration) {
        requestAnimationFrame(animation);
      }
      else {
        resolve();
      }
    };

    requestAnimationFrame(animation);
  });
  const printElements = document.querySelectorAll('.show-for-print');

  const handleSave = async() => {
    if (selectedLanguage === 'en') {
      props.onClose();
      window.print();
    }
    else {
      printElements.forEach(el => el.classList.add('force-show'));

      await new Promise(resolve => setTimeout(resolve, 5000));
      await smoothScrollTo(document.body.scrollHeight, 10000);
      await new Promise(resolve => setTimeout(resolve, 1000));
      await smoothScrollTo(0, 1000);

      setTimeout(() => {
        props.onClose();
        setPreparingDocument(false);
        window.print();
        printElements.forEach(el => el.classList.remove('force-show'));
      }, 100);
    }
  };

  return (
    <div
      className='modal hide-for-print'
      onClick={props.onClose}>
      <div
        className='padding-3 width-50 white-bg-color all-rounded-borders'
        onClick={e => e.stopPropagation()}>
        <div className='modal-header'>
          {
            preparingDocument
              ? <div>
                <h2 className='margin-0'>Please wait while we prepare the report.<br/>This may take few seconds.</h2>
                <div className='position-relative'>
                  <span className='loader'/>
                </div>
              </div>
              : <div>
                <h2 className='margin-bottom-2'>Print or Save as PDF</h2>
              </div>
          }
        </div>
        <div className='modal-content'>
          <h3 className='info-color text-uppercase'>
            Here are instructions to save this summary report as pdf
          </h3>
          <ol className='modal-instructions'>
            <li>
              <div>Click the &quot;Print or Save to PDF&quot; button.</div>
            </li>
            <li>
              <div>Change the &quot;Destination&quot; to &quot;Save as PDF&quot; in the print dialog.</div>
            </li>
            <li>
              <div>Click &quot;Save&quot; or &quot;Save As&quot;</div>
            </li>
          </ol>
        </div>
        <div className='modal-footer margin-top-2'>
          <button
            className='button large hollow rounded padding-horizontal-2'
            onClick={() => {
              props.onClose();
              setPreparingDocument(false);
              printElements.forEach(el => el.classList.remove('force-show'));
            }}
            type='button'>
            Close
          </button>
          <button
            className={`button large rounded padding-horizontal-2 ${preparingDocument ? 'disabled' : ''}`}
            onClick={() => {
              setPreparingDocument(true);
              handleSave();
            }}
            type='button'>
            Print or Save to PDF
          </button>
        </div>
      </div>
    </div>
  );
};

export default PrintStepsModal;

PrintStepsModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired
};
